import { css } from '@compiled/react';
import { FormattedMessage, useIntl } from 'react-intl';

import { media } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { Picture } from '@/components/wpl/image/src/image';
import { Link } from '@/libraries/design/components/link/src/link';
import { Row } from '@/libraries/wpl/foundations/src/grid';

const Community = () => {
	const intl = useIntl();

	return (
		<section css={section}>
			<Row layout="6-6" alignItems="center">
				<Picture
					image={{
						src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/tj67uy2v6dlh816537m17ay3p0qwy6y2.webp',
						alt: '',
					}}
					css={img}
				/>
				<div>
					<h2 className="h4">
						<FormattedMessage
							id="JiraProductDiscoveryPage.community.heading"
							defaultMessage="Join us in the Atlassian Community"
						/>
					</h2>
					<p>
						<FormattedMessage
							id="JiraProductDiscoveryPage.community.subheading"
							defaultMessage="Ask questions, give app feedback, and connect with our team and other users to learn best practices."
						/>
					</p>
					{/* eslint-disable-next-line @atlassian/a11y/anchor-has-content, @atlassian/a11y/link-name */}
					<Link
						text={intl.formatMessage({
							id: 'JiraProductDiscoveryPage.community.ctaText',
							defaultMessage: 'Join the discussion',
						})}
						href="https://community.atlassian.com/t5/Jira-Product-Discovery/ct-p/jpd"
						type="primary"
						dataEventProps={{
							'data-event-component': 'linkButton',
							'data-event-container': 'pronouncedCtaSection',
							'data-event': 'clicked',
							'data-product-key': 'jiraProductDiscovery',
						}}
					/>
				</div>
			</Row>
		</section>
	);
};

export default Community;

const section = css({
	marginBlock: token('space.1000'),
});
const img = css({
	// Need to target the img inside the picture
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	img: {
		maxWidth: '100%',
		height: 'auto',
		[media.above.sm]: {
			paddingInlineEnd: token('space.400'),
		},
	},
});
